import { render, staticRenderFns } from "./ServiceDashboardSummaryCardEssayReview.vue?vue&type=template&id=ec55f838&"
import script from "./ServiceDashboardSummaryCardEssayReview.vue?vue&type=script&lang=js&"
export * from "./ServiceDashboardSummaryCardEssayReview.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDashboardSummaryCardEssayReview.vue?vue&type=style&index=0&id=ec55f838&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports